module.exports = __webpack_public_path__ + "static/media/0024_IMG_TRAD_LE_SOL_MEGALITH_MEGABLACK.68de73b6.png";